import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import { AppLayout } from '#components/applayout/AppLayout.tsx';
import { ErrorBoundary } from '#components/shared/ErrorBoundary.tsx';
import RouteErrorFallback from '#components/shared/RouteErrorFallback.tsx';
import { OrderPage } from '#pages/OrderPage.tsx';
import { TourPage } from '#pages/TourPage.tsx';
import TourServicePage from '#pages/TourServicePage.tsx';
import { WelcomePage } from '#pages/WelcomePage.tsx';

import { routes } from './routes.ts';

const routesFromElements = createRoutesFromElements(
    <Route element={<AppLayout />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.WELCOME} element={<WelcomePage />} />
        <Route
            path={routes.TOURSERVICE}
            element={
                <ErrorBoundary>
                    <TourServicePage />
                </ErrorBoundary>
            }
        >
            <Route
                path=':tourId'
                element={
                    <ErrorBoundary>
                        <TourServicePage />
                    </ErrorBoundary>
                }
            />
        </Route>
        <Route
            path={routes.ORDERS}
            element={
                <ErrorBoundary>
                    <OrderPage />
                </ErrorBoundary>
            }
        >
            <Route
                path=':orderId'
                element={
                    <ErrorBoundary>
                        <OrderPage />
                    </ErrorBoundary>
                }
            />
            <Route
                path='*'
                element={
                    <ErrorBoundary>
                        <OrderPage />
                    </ErrorBoundary>
                }
            />
        </Route>
        <Route
            path={routes.TOURS}
            element={
                <ErrorBoundary>
                    <TourPage />
                </ErrorBoundary>
            }
        >
            <Route
                path=':tourId'
                element={
                    <ErrorBoundary>
                        <TourPage />
                    </ErrorBoundary>
                }
            />
        </Route>

        <Route path='*' element={<Navigate to={routes.ORDERS} />} />
    </Route>
);

export const appRouter = createHashRouter(routesFromElements);
